<script setup lang="ts">

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { IconContainer } from '@shared/ui/other'
import { LinkTextPrimaryMedium, LinkTextSecondaryMedium } from '@shared/ui/links'

import { useTaskRelationCustomer } from '../../model/task-relation-customer.hook'

defineOptions({
  name: 'TaskRelationCustomer',
})

const {
  refHasCustomer,
  refIsGo,
  refBrand,
  refRespondUrl,
  refHref,
  refLabel,
} = useTaskRelationCustomer()
</script>

<template>
  <div class="relations">
    <AppBadge
      v-if="refIsGo"
      class="relations__go"
      color="emerald"
      text="Goal"
    />
    <BadgeCustomerBrand
      :brand="refBrand"
      view="icon"
    />
    <LinkTextPrimaryMedium
      v-if="refHasCustomer"
      :href="refHref"
      target="_blank"
    >
      {{ refLabel }}
      <IconContainer>
        <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
      </IconContainer>
    </LinkTextPrimaryMedium>
    <LinkTextSecondaryMedium
      v-if="refRespondUrl"
      :href="refRespondUrl"
      target="_blank"
    >
      Respond
      <template #iconRight>
        <IconContainer>
          <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
        </IconContainer>
      </template>
    </LinkTextSecondaryMedium>
    <template v-if="!refHasCustomer">
      -
    </template>
  </div>
</template>

<style scoped lang="scss" src="./TaskRelationCustomer.scss" />
